import { PureComponent } from 'react';
import { number } from 'prop-types';

import { select } from 'd3-selection';
import { easeCubicInOut } from 'd3-ease';
// d3-transition extends d3-selection with transition capabilities
import 'd3-transition';

/**
 * Draws a SVG circle element and animates it when the props change.
 *
 * @author Nick Rutten <nick@cleverfranke.com>
 * @class AnimatedCircle
 * @extends {PureComponent}
 */
class AnimatedCircle extends PureComponent {
  componentDidUpdate() {
    const { cxPosition, cyPosition } = this.props;

    select(this.circleElement)
      .transition()
      .duration(200)
      .ease(easeCubicInOut)
      .attr('cx', cxPosition)
      .attr('cy', cyPosition);
  }

  componentDidMount() {
    const { cxPosition, cyPosition } = this.props;

    select(this.circleElement)
      .attr('cx', cxPosition)
      .attr('cy', cyPosition)
      .transition()
      .duration(200)
      .ease(easeCubicInOut)
      .attr('opacity', 1);
  }

  render() {
    const { ...presentational } = this.props;
    delete presentational.cxPosition;
    delete presentational.cyPosition;
    return (
      <circle
        opacity="0"
        ref={(ref) => (this.circleElement = ref)}
        {...presentational}
      />
    );
  }
}

AnimatedCircle.propTypes = {
  /** SVG x-coordinate */
  cxPosition: number.isRequired,
  /** SVG y-coordinate */
  cyPosition: number.isRequired,
};

export default AnimatedCircle;
